import React from 'react';
import AndroidRounded from '@material-ui/icons/AndroidRounded';
import ExtensionRounded from '@material-ui/icons/ExtensionRounded';
import TextsmsRounded from '@material-ui/icons/TextsmsRounded';
import GavelRounded from '@material-ui/icons/GavelRounded';
import WidgetsRounded from '@material-ui/icons/WidgetsRounded';
import EmojiObjectsRounded from '@material-ui/icons/EmojiObjectsRounded';
import PowerRounded from '@material-ui/icons/PowerRounded';
import MenuBookRounded from '@material-ui/icons/MenuBookRounded';
import type { IconName } from './typeMetadata';

const ICON_MAP: Record<
  IconName,
  React.ComponentType<{
    style?: React.CSSProperties;
    fontSize?: 'inherit' | 'medium' | 'small' | 'large';
  }>
> = {
  smart_toy: AndroidRounded,
  bolt: ExtensionRounded,
  chat_bubble: TextsmsRounded,
  gavel: GavelRounded,
  widgets: WidgetsRounded,
  psychology: EmojiObjectsRounded,
  power: PowerRounded,
  menu_book: MenuBookRounded,
};

interface TypeIconProps {
  iconName: IconName;
  style?: React.CSSProperties;
  fontSize?: 'inherit' | 'medium' | 'small' | 'large';
}

export function TypeIcon({
  iconName,
  style,
  fontSize = 'medium',
}: TypeIconProps) {
  const Icon = ICON_MAP[iconName];
  return <Icon style={style} fontSize={fontSize} />;
}
